const buttonStyle_desktop = {
    marginTop: 15,
    width: 'fit-content',
    borderRadius: 7,
    backgroundColor: 'black',
    border:'2px solid red',
    color: 'white',
    padding: 4,
    fontSize:"2vw"
}

const buttonStyle_mobile = {
    marginTop: 15,
    width: 'fit-content',
    borderRadius: 3,
    backgroundColor: 'black',
    border:'.5px solid red',
    color: 'white',
    padding: 4,
    fontSize:"1.6vh"
}

const buttonStyle_about_me = {
    marginTop: 15,
    marginBottom:15,
    marginLeft: 20,
    width: 'fit-content',
    borderRadius: 3,
    backgroundColor: 'black',
    border:'.5px solid red',
    color: 'white',
    padding: 4,
    fontSize:"1.6vh"
}

const buttonStyle_about_me_desktop = {
    marginTop: 25,
    marginBottom:15,
    marginLeft: 20,
    width: 'fit-content',
    borderRadius: 3,
    backgroundColor: 'black',
    border:'.5px solid red',
    color: 'white',
    padding: 4,
    fontSize:"3.5vh"
}

export {buttonStyle_desktop, buttonStyle_mobile, buttonStyle_about_me, buttonStyle_about_me_desktop};